<template>
  <div>
    <section class="referrals loading" v-if="isLoading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </section>
    <section class="referrals loading" v-else-if="error">
      <p>{{ error }}</p>
    </section>
    <section class="referrals" v-else>
      <div class="top">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <h1>Referral Program</h1>
              <div class="row summary-row">
                <div class="col-md-6 count-row">
                  <strong>You have a total of <span>{{ numReferrals }} {{ pluralizeReferrals(numReferrals) }}</span></strong>
                </div>
                <div class="col-md-6 next-row">
                  You're only <strong>{{ numReferralsToNextReward }} {{ pluralizeReferrals(numReferralsToNextReward) }}</strong> away from the next reward
                </div>
              </div>
              <div class="rewards-container">
                <div class="progress-bar row" :style="{'--level': levelPercentage || 0.01}">
                  <div class="col"></div>
                </div>
                <div class="row rewards">
                  <div :class="['col', {achieved: reward.num <= numReferrals}]" v-for="(reward, x) in rewards" :key="x">
                    <div class="name">
                      <strong>{{ reward.name }}</strong>
                      <span>{{ reward.num }} Referrals</span>
                    </div>
                    <div class="reward-image">
                      <img :src="reward.image" :alt="reward.name" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <h2>Get more referrals</h2>
              <div class="row">
                <div class="col-lg-7 col-md-6">
                  <div class="box">
                    <h3>Share your link</h3>
                    <form class="form form-inline">
                      <input type="text" id="referral-link" :value="`https://newsletter.skylineconference.co/referral/${code}`" class="form-control" readonly ref="referralLink" />
                      <button type="button" class="btn btn-primary" v-on:click="copyReferralLink">{{ copyText }}</button>
                    </form>
                  </div>
                </div>
                <div class="col-lg-5 col-md-6">
                  <div class="box">
                    <h3>Share on social media</h3>
                    <ul class="social-icons">
                      <li>
                        <ShareNetwork
                          network="facebook"
                          :url="`https://newsletter.skylineconference.co/referral/${code}`"
                          description="Sign up for the Skyline newsletter">
                          <img src="../assets/facebook-white.svg" alt="Facebook" />
                        </ShareNetwork>
                      </li>
                      <li>
                        <ShareNetwork
                          network="linkedin"
                          :url="`https://newsletter.skylineconference.co/referral/${code}`">
                          <img src="../assets/linkedin-white.svg" alt="LinkedIn" />
                        </ShareNetwork>
                      </li>
                      <li>
                        <ShareNetwork
                          network="twitter"
                          :url="`https://newsletter.skylineconference.co/referral/${code}`"
                          title="Sign up for the Skyline newsletter">
                          <img src="../assets/twitter-white.svg" alt="Twitter" />
                        </ShareNetwork>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-12">
                  <div class="box">
                    <div class="row justify-content-between">
                      <div class="col-lg-4 col-md-6">
                        <h3>Share via email</h3>
                        <p>Invite your friends, family or network to join our newletter in their emails. (We’ll automatically add your referral link!)</p>
                      </div>
                      <div class="col-md-6">
                        <form class="form" v-on:submit="sendInvite" novalidate="">
                          <div class="form-group">
                            <input type="email" name="email" id="email" placeholder="Enter contact email address" class="form-control" v-model="emails"/>
                            <span class="help-block">Separate multiple emails with commas</span>
                          </div>
                          <div class="form-group">
                            <textarea class="form-control" name="message" id="message" rows="5" v-model="message"></textarea>
                          </div>
                          <div class="form-group submit-container">
                            <button type="submit" class="btn btn-primary">
                              <span v-if="!isLoadingInvite">Submit</span>
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-else></span>
                            </button>
                            <p class="invite-response invite-error" v-if="inviteError">{{ inviteError }}</p>
                            <p class="invite-response invite-success" v-if="inviteSuccess">{{ inviteSuccess }}</p>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import axios from "axios"
import Footer from "../components/Footer.vue"

export default {
  name: 'Dashboard',
  data: function () {
    return {
      numReferrals: 0,
      code: "",
      isLoading: false,
      copyText: "Copy Link",
      error: "",
      isLoadingInvite: false,
      emails: "",
      message: "",
      inviteError: "",
      inviteSuccess: "",
      rewards: [
        {
          name: "Stickers",
          num: 5,
          image: require('../assets/reward-stickers.png'),
        },
        {
          name: "Phone Wallet",
          num: 15,
          image: require('../assets/reward-phone-wallet.png'),
        },
        {
          name: "T-Shirt",
          num: 25,
          image: require('../assets/reward-t-shirt.png'),
        },
        {
          name: "Coffee Mug",
          num: 50,
          image: require('../assets/reward-mug.png'),
        },
        {
          name: "Conference Ticket",
          num: 100,
          image: require('../assets/reward-tickets.png'),
        },
        {
          name: "Stage time + Tickets",
          num: 500,
          image: require('../assets/reward-speaker.png'),
        },
      ]
    }
  },
  computed: {
    levelPercentage: function () {
      let currLevel = 0
      this.rewards.forEach((reward) => {
        if (this.numReferrals >= reward.num) {
          currLevel++
        }
      })

      return currLevel / this.rewards.length
    },
    numReferralsToNextReward: function () {
      let nextRewardIn = 0
      for (let i = 0; i < this.rewards.length; i++) {
        if (this.numReferrals < this.rewards[i].num) {
          nextRewardIn = this.rewards[i].num - this.numReferrals
          break
        }
      }

      return nextRewardIn
    },
  },
  mounted: function () {
    // get referral status
    axios.get(`/api/user/${this.$route.params.userCode}/status`)
      .then((response) => {
        this.isLoading = false
        this.numReferrals = response.data.referrals
        this.code = response.data.code
      })
      .catch(() => {
        this.isLoading = false
        this.error = "We couldn't find your referral code, please try clicking on the link in your email again."
      })
  },
  methods: {
    pluralizeReferrals: (num) => {
      return 'referral' + (num != 1 ? 's' : '')
    },
    copyReferralLink: function (e) {
      e.preventDefault()
      this.$refs.referralLink.select()
      document.execCommand('copy')
      this.copyText = 'Copied'
    },
    sendInvite: function(e) {
      e.preventDefault()
      this.inviteError = ""
      this.inviteSuccess = ""

      if (this.emails.trim() == "") {
        this.inviteError = "Please include at least one email"
      }
      else {
        this.isLoadingInvite = true
        axios.post(`/api/invite`, {
            emails: this.emails,
            message: this.message,
            referralCode: this.code
          })
          .then((response) => {
            this.isLoadingInvite = false
            this.inviteSuccess = response.data.message
            this.emails = ""
            this.message = ""
          })
          .catch((error) => {
            this.isLoadingInvite = false
            if (error.response) {
              this.inviteError = error.response.data.error
            }
            else {
              this.inviteError = "Sorry, something went wrong. Please try again later."
            }
          })
      }
    },
  },
  components: {
    Footer,
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables";

section.referrals {
  &.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
  }
  &:not(.loading) {
    padding-top: 130px;
  }
}

h1 {
  font-size: 45px;
  font-weight: 700;
  line-height: 1.3333;
  margin: 0 0 40px;

  @media all and (max-width: $mobileMax) {
    font-size: 30px;
  }
}

div.summary-row {
  align-items: center;
}

div.count-row {
  font-size: 16px;

  @media all and (max-width: $mobileMax) {
    margin-bottom: 1em;
  }

  span {
    color: $pink;
  }
}

div.next-row {
  font-size: 14px;
  text-align: right;

  @media all and (max-width: $mobileMax) {
    text-align: left;
  }
}

div.rewards-container {
  @media all and (max-width: $mobileMax) {
    position: relative;
    margin-top: 2em;
  }
}

div.progress-bar {
  margin-top: 18px;
  margin-bottom: 30px;
  height: 17px;

  @media all and (max-width: $mobileMax) {
    position: absolute;
    top: 0;
    height: 100%;
    left: 15px;
    margin-top: 0;
    margin-bottom: 0;
  }

  div.col {
    background-color: #F5F5F5;
    position: relative;

    @media all and (max-width: $mobileMax) {
      height: 100%;
    }

    &:after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      background-color: $green;
      width: 0;
      animation-name: widthAnimation;
      animation-fill-mode: forwards;
      animation-duration: 2s;

      @media all and (max-width: $mobileMax) {
        animation-name: heightAnimation;
        width: 100%;
      }

      @keyframes widthAnimation {
        from {
          width: 0;
        }
        to {
          width: calc(var(--level) * 100%);
        }
      }

      @keyframes heightAnimation {
        from {
          height: 0;
        }
        to {
          height: calc(var(--level) * 100%);
        }
      }
    }
  }
}

div.rewards {
  div.col {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    border-right: 1px solid #F5F5F5;

    @media all and (max-width: $mobileMax) {
      width: 100%;
      flex: 0 0 100%;
      margin-bottom: 2em;
    }

    &:last-child {
      border-right: none;
    }

    &.achieved {
      position: relative;

      &:before {
        content: "";
        display: block;
        width: 12px;
        height: 12px;
        background-image: url("data:image/svg+xml,%3Csvg width='12px' height='12px' viewBox='0 0 12 12' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Referrals' transform='translate(-304.000000, -339.000000)'%3E%3Crect id='Rectangle' fill='%23FFFFFF' x='-1' y='64' width='1441' height='467'%3E%3C/rect%3E%3Cg id='Group-15' transform='translate(304.000000, 339.000000)'%3E%3Cpath d='M6,0 C9.32009926,0 12,2.69478908 12,6 C12,9.32009926 9.32009926,12 6,12 C2.69478908,12 0,9.32009926 0,6 C0,2.69478908 2.69478908,0 6,0 Z' id='Shape' fill='%2395EF5B'%3E%3C/path%3E%3Cpolygon id='Path' fill='%23000000' points='4.74937965 7.38461538 9.08188586 3.05210918 9.87096774 3.84119107 4.74937965 8.96277916 2.1439206 6.34243176 2.93300248 5.55334988'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        background-repeat: no-repeat;
        position: absolute;
        top: 16px;
        left: 10px;

        @media all and (max-width: $mobileMax) {
          left: 60px;
          top: calc(50% + 1em);
        }
      }
    }

    div.name {
      font-size: 12px;
      min-height: 4em;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin: 0 0 17px;
      text-align: center;
    }

    div.reward-image {
      flex-grow: 1;
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;

      img {
        max-width: 75%;
        height: auto;
        max-height: 111px;
        width: auto;
      }
    }
  }
}

div.top {
  padding-bottom: 18px;
}

div.bottom {
  background-color: #F5F5F5;
  padding-top: 32px;
  padding-bottom: 90px;
}

h2 {
  font-size: 25px;
  line-height: 2.4;
}

div.box {
  background-color: white;
  padding: 36px 50px;
  height: calc(100% - 18px);
  margin-bottom: 18px;

  @media all and (max-width: $mobileMax) {
    padding-left: 15px;
    padding-right: 15px;
  }

  h3 {
    font-size: 20px;
    line-height: 1.2;
    margin: 0 0 25px;
  }

  input.form-control,
  textarea.form-control {
    border: 1px solid #D8D8D8;
    border-radius: 0;
    flex-grow: 1;
    margin: 0 25px 0 0;
    font-size: 14px;
    letter-spacing: 0.2px;
    line-height: 1.29;
    background-color: white;

    @media all and (max-width: $tabletMax) {
      width: 100%;
      display: block;
      margin-right: 0;
      margin-bottom: 1em;
    }
  }

  button.btn.btn-primary {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.24px;
    text-transform: uppercase;

    @media all and (max-width: $tabletMax) {
      display: block;
      width: 100%;
    }
  }

  p {
    font-size: 12px;
    letter-spacing: 0.17px;
    line-height: 1.5;
  }
}

ul.social-icons {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  li {
    padding-right: 15px;

    &:last-child {
      padding-right: 0;
    }

    a {
      display: block;
      width: 38px;
      height: 38px;
      background-color: $pink;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
}

.btn.btn-outline-primary {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.24px;
  text-transform: uppercase;

  @media all and (max-width: $mobileMax) {
    width: 100%;
    display: block;
    margin-bottom: 1em;
  }
}

span.help-block {
  font-size: 12px;
  letter-spacing: 0.17px;
  line-height: 1.5;
  display: block;
  margin: 0.5em 0;
}

div.submit-container {
  text-align: center;

  button.btn.btn-primary {
    padding-left: 2em;
    padding-right: 2em;
  }
}

p.invite-response {
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  margin: 1em 0 0;
}
</style>
